<template>
    <div class="log-in-screen">

        <div class="logo-wrap">
            <img alt="F&B Logo" src="../../assets/logo.png">
        </div>
        <h1>Dołącz do<br/>tysięcy kreatywnych <br class="hide-lg"/>influencerów</h1>

        <loader v-if="loading" />

        <h2 v-if="!loading">Zarejestruj się<span class="purple-text">.</span></h2>
        <div class="buttons-wrap" v-if="!loading">
            <log-in-button v-on:login="handleLogInFacebook" type="facebook" text="Zarejestruj z Facebook" />
            <div ref="google">
                <log-in-button type="google" text="Zarejestruj z Google" />
            </div>
        </div>
        <div class="terms-footer">
            Rejestrując się wyrażasz zgodę na <a target="_blank" href="https://influencerzy.friendsandbrands.pl/terms/Friends&Brands_Regulamin.pdf">Regulamin</a><br class="hide-lg" />
            serwisu oraz <a target="_blank" href="https://influencerzy.friendsandbrands.pl/terms/Friends&Brands_Polityka_prywatnosci.pdf">Politykę prywatności</a>.
        </div>
    </div>
</template>

<script>
    import LogInButton from '@/components/LogIn/LogInButton';
    import Loader from "../Loader";

    export default {
        name: 'LogIn',
        components: {Loader, LogInButton},
        props: {
            onLogIn: Function,
            onFakeLogIn: Function,
            loading: Boolean
        },
        mounted() {
            gapi.load('auth2', () => {this.handleGapiInitialization()});
        },
        methods: {
            handleLogInFacebook() {
                this.onLogIn({type: 'facebook'});
            },
            handleFakeLogIn() {
                this.onFakeLogIn();
            },
            handleGapiInitialization: function () {
                let isntance = gapi.auth2.init();

                if(!this.$refs.google) return;

                isntance.attachClickHandler(this.$refs.google, {},
                    (googleUser) => {
                        this.onLogIn({type: 'google', token: googleUser.getAuthResponse().id_token});
                    }
                );
            }
        }
    }
</script>
